// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <!-- [guanxing patch] M-SW15：本命星命弹窗（用户需求「输入完成之后先弹出一个弹窗，
       展示星座/本命宿/星次/本命星君」）。提交出生信息或 birth=1 直达时弹出；
       点遮罩/✕ 关闭只关弹窗不动作。卡片皮肤走 M-SW12 的 v-dialog v-card 毛玻璃
       全局皮肤 + 本组件 token 细化（与 birth-card 同族）。
       [guanxing patch] M-SW19（用户需求「取消下面的两个按钮 改成 点击上面的
       星座 星次 等等 直接跳转」）：底部两按钮移除，四行整行可点直接跳转——
       星座行发 view-zodiac、星次行发 view-xingci（跳星次对应星座）、
       本命宿行发 view-mansion、本命星君行发 view-lord（M-SW53：星君行
       独立事件，携带星君上下文跳同一宿）。
       [guanxing patch] M-SW53（用户需求「星次/本命星君要自己独特的文化知识
       介绍，星座介绍添加独属于这个星座的介绍」）：四行各附一句独属文化摘要
       （.fate-sum：星座取 ZODIAC_SUMMARY、星次/宿/星君取 birth-fate.js
       新增 sum/lordSum 字段），打开弹窗不跳转即可读到。
       [guanxing patch] M-SW25（用户需求）：新增第五行「你出生时的太阳系」
       发 view-solar 打开全屏太阳系（M-SW9 底栏入口同步移除，弹窗保持打开）。 -->
  <v-dialog v-model="show" max-width="420" content-class="birth-fate-dialog">
    <v-card class="fate-card">
      <v-btn icon small class="fate-close" @click.stop="show = false">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      <div class="fate-title">你的星命</div>
      <div class="fate-sub">{{ fate.dateText }} · {{ fate.cityText }}</div>

      <div class="fate-rows">
      <!-- [guanxing patch] M-SW25（用户需求「太阳系的按钮改到星命中的一栏
             你出生时的太阳系」）：底栏太阳系入口（M-SW9）迁入本弹窗，第五行
             打开全屏太阳系对话框，?t= 定位到出生瞬间（solar-system-dialog 按
             store 的 solarSystemBirthIso 换算）。弹窗保持打开，关闭太阳系回到本卡。 -->
        <div class="fate-row" @click.stop="$emit('view-zodiac')">
          <div class="fate-label">星座</div>
          <div class="fate-value">{{ fate.sign && fate.sign.zh }}</div>
          <!-- [guanxing patch] M-SW53：每行附独属文化摘要（不跳转就能看到）。 -->
          <div class="fate-sum" v-if="signSum">{{ signSum }}</div>
          <div class="fate-hint">生日所在占星十二宫 · 点击跳转</div>
        </div>
        <div class="fate-row" @click.stop="$emit('view-xingci')">
          <div class="fate-label">星次</div>
          <div class="fate-value">{{ fate.xingci && fate.xingci.name }}</div>
          <div class="fate-sum" v-if="fate.xingci">{{ fate.xingci.sum }}</div>
          <div class="fate-hint" v-if="fate.xingci">出生时太阳所在中国十二星次（{{ fate.xingci.qi }}）· 点击跳转{{ fate.xingci.sign }}</div>
        </div>
        <div class="fate-row" @click.stop="$emit('view-mansion')">
          <div class="fate-label">本命宿</div>
          <div class="fate-value">{{ fate.mansion && fate.mansion.name }}宿</div>
          <div class="fate-sum" v-if="fate.mansion">{{ fate.mansion.sum }}</div>
          <div class="fate-hint" v-if="fate.mansion">出生时月亮所在二十八宿 · {{ fate.mansion.group }} · 点击跳转</div>
        </div>
        <div class="fate-row" @click.stop="$emit('view-lord')">
          <div class="fate-label">本命星君</div>
          <div class="fate-value">{{ fate.mansion && fate.mansion.lord }}</div>
          <div class="fate-sum" v-if="fate.mansion">{{ fate.mansion.lordSum }}</div>
          <div class="fate-hint" v-if="fate.mansion">二十八宿星君 · {{ fate.mansion.name }}宿 · 点击跳转该宿</div>
        </div>
        <!-- [guanxing patch] M-SW25（用户需求「太阳系的按钮改到星命中的一栏
             你出生时的太阳系」）：底栏太阳系入口（M-SW9）迁入本弹窗，第五行
             打开全屏太阳系对话框，?t= 定位到出生瞬间（solar-system-dialog 按
             store 的 solarSystemBirthIso 换算）。弹窗保持打开，关闭太阳系回到本卡。 -->
        <div class="fate-row" @click.stop="$emit('view-solar')">
          <div class="fate-label">太阳系</div>
          <div class="fate-value">你出生时的太阳系</div>
          <div class="fate-hint">{{ fate.dateText }} · 日心视角俯瞰那一刻的行星轨道 · 点击飞出地球</div>
        </div>
      </div>

      <div class="fate-tip">点击任一行，跳转对应星空或太阳系</div>
    </v-card>
  </v-dialog>
</template>

<script>

// [guanxing patch] M-SW53：十二星座一句话独属摘要（星座行 .fate-sum）。
import { ZODIAC_SUMMARY } from '@/assets/birth-fate.js'

export default {
  props: {
    // v-model：弹窗显隐
    value: { type: Boolean, default: false },
    // 本命信息：{ dateText, cityText, sign, xingci, mansion }（App.vue computeBirthFate 产出）
    fate: { type: Object, required: true }
  },
  computed: {
    show: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    },
    // [guanxing patch] M-SW53：星座行摘要（按生日星座中文名查 ZODIAC_SUMMARY）。
    signSum: function () {
      return (this.fate.sign && ZODIAC_SUMMARY[this.fate.sign.zh]) || ''
    }
  }
}
</script>

<style>

/* [guanxing patch] M-SW15：弹窗卡片底色/细边/圆角/毛玻璃由 M-SW12 全局皮肤
   .v-application .v-dialog .v-card 提供（同一套 token，不重复声明避免特异性竞争）；
   这里只做布局与内容排版。 */
.birth-fate-dialog .fate-card {
  padding: 24px 24px 20px;
  position: relative;
}

.birth-fate-dialog .fate-close {
  position: absolute;
  top: 10px;
  right: 10px;
}

.birth-fate-dialog .fate-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}

.birth-fate-dialog .fate-sub {
  font-size: 12px;
  color: var(--gx-text-dim);
  margin-bottom: 16px;
}

.birth-fate-dialog .fate-rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

/* [guanxing patch] M-SW19：整行可点（去按钮改直跳），hover 反馈提示可交互。 */
.birth-fate-dialog .fate-row {
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--gx-panel-border);
  border-radius: var(--gx-radius-ctrl);
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}
.birth-fate-dialog .fate-row:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.5);
}

.birth-fate-dialog .fate-label {
  font-size: 12px;
  color: var(--gx-text-dim);
  margin-bottom: 2px;
}

.birth-fate-dialog .fate-value {
  font-size: 18px;
  font-weight: 600;
  color: var(--gx-gold);
  line-height: 1.3;
}

.birth-fate-dialog .fate-hint {
  font-size: 11px;
  color: var(--gx-text-dim);
  margin-top: 2px;
  line-height: 1.5;
}

/* [guanxing patch] M-SW53：行内独属文化摘要（.fate-sum，介于 value 与 hint 之间，
   金色弱化为正文灰白，与 hint 区分层级）。 */
.birth-fate-dialog .fate-sum {
  font-size: 12px;
  color: var(--gx-text);
  margin-top: 4px;
  line-height: 1.5;
}

/* [guanxing patch] M-SW19：底部操作提示（取代原两按钮）。 */
.birth-fate-dialog .fate-tip {
  text-align: center;
  font-size: 12px;
  color: var(--gx-text-dim);
}

</style>
